export const PublishedNewsOptions = [
  { value: 'All', label: 'Sve novosti' },
  { value: 'Published', label: 'Objavljene novosti' },
  { value: 'Draft', label: 'Neobjavljene novosti' },
];
